module.exports = __webpack_public_path__ + "static/media/history.61b497ae.svg";